import { Component, Prop, Vue } from 'vue-property-decorator';
import style from '@/assets/styles/dialog.module.less';
@Component
export default class CommonDialog extends Vue {
  // 传递的是展示的数组
  @Prop() private unActive!: () => void;
  // stpj上调评级弹窗 szkj上涨空间 stjs上调家数
  @Prop() private type!: 'stpj' | 'szkj' | 'stjs';
  // 文案
  infoObj = {
    stpj: '最新上调评级的机构，该机构最近两份研报的评级变化',
    szkj: '(所选时间内的研报目标均价-昨日收盘价) / 昨日收盘价',
    stjs: '所选时间对该个股进行至少两次评级，并且评级上调的机构数',
  };
  get info() {
    // 文案内容
    return this.infoObj[this.type];
  }
  show() {
    // 展示事件
    document.body.style.setProperty('overflow', 'hidden');
  }
  close() {
    // 关闭
    document.body.style.setProperty('overflow', '');
    this?.unActive && this.unActive();
    this.$nextTick(() => {
      this.$el.parentNode?.removeChild(this.$el);
    });
  }
  // eslint-disable-next-line no-unused-vars
  render(h) {
    return (
      <div class={style['com-dialog']} onClick={this.close}>
        <div class={style['com-dialog-container']}>
          <div class={style['com-dialog-intro']}>{this.info}</div>
          <div class={style['com-dialog-btn']} onClick={this.close}>
            我知道了
          </div>
        </div>
      </div>
    );
  }
  mounted() {
    // 展示处理
    this.show();
  }
}
